
(function(){
  var variants = window.productVariants || ShopifyAnalytics.meta.product.variants;

  // 超过这个词数，判定为自动生成的产品标题/长描述，当作通用图片处理
  var MAX_WORDS_FOR_TAG = 6;

  function getCheckedValues() {
    var vals = [];
    document.querySelectorAll('.option-selector__btns input:checked').forEach(function(el){
      vals.push(el.value.toLowerCase().trim());
    });
    return vals;
  }

 function getVariantParts(variantName) {
  if(!variantName) return [];
  var name = variantName.toLowerCase();
    var dashIndex = name.indexOf(' - ');
    if(dashIndex !== -1) name = name.substring(dashIndex + 3);
    return name.split(' / ').map(function(s){ return s.trim(); });
  }

  // 按选项组（Color / Size...）分别收集该组的所有选项值，每组单独存一个数组
  function getOptionGroups() {
    var groups = [];
    document.querySelectorAll('.option-selector__btns').forEach(function(group){
      var vals = [];
      group.querySelectorAll('input').forEach(function(el){
        var v = el.value.toLowerCase().trim();
        if (v !== '') vals.push(v);
      });
      // 按长度从长到短排序，确保匹配时优先尝试更长（更具体）的值
      vals.sort(function(a, b){ return b.length - a.length; });
      groups.push(vals);
    });
    return groups;
  }

  function updateAvailability() {
    var checked = getCheckedValues();
    var groupEls = document.querySelectorAll('.option-selector__btns');

    groupEls.forEach(function(group, groupIndex){
      group.querySelectorAll('input').forEach(function(input){
        var thisValue = input.value.toLowerCase();

var hasMatch = variants.some(function(v){
var parts=getVariantParts(v.public_title);
if(parts[groupIndex]!==thisValue)return false;
if(!checked.every(function(val,i){
if(i===groupIndex)return true;
return parts[i]===val;
})) return false;
return v.available !== false;
});

    var label=input.nextElementSibling;

if(!hasMatch){
input.classList.add('is-unavailable');
if(label) label.classList.add('is-unavailable');
}else{
input.classList.remove('is-unavailable');
if(label) label.classList.remove('is-unavailable');
}
      });
    });
  }

  function isAutoGeneratedAlt(alt) {
    if (alt === '') return true;
    var wordCount = alt.split(/\s+/).filter(function(w){ return w.length > 0; }).length;
    return wordCount > MAX_WORDS_FOR_TAG;
  }

  // 在一组选项值（已按长度从长到短排序）里，找出 alt 中出现的最长匹配
  // 例如 alt = "dark green king single"，size 组里 "king single" 命中后，
  // "king" 不会在这组里重复命中（因为先按长度排序，先试长的）
  function matchLongestInGroup(alt, sortedVals) {
    for (var i = 0; i < sortedVals.length; i++) {
      var val = sortedVals[i];
      // 用单词边界判断，避免子串误判（如 king 误中更长的词内部）
      var pattern = new RegExp('(^|\\s)' + val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|\\s)');
      if (pattern.test(alt)) {
        return val;
      }
    }
    return null;
  }


  function updateCustomAvailability(){
document.querySelectorAll('.custom-color-swatch').forEach(function(swatch){
var color=swatch.dataset.colorValue;
var input=document.querySelector('input[name*="color-option"][value="'+color+'"]');
if(!input)return;
swatch.classList.toggle('is-unavailable',input.classList.contains('is-unavailable'));
});
document.querySelectorAll('.custom-size-card').forEach(function(card){
var size=card.dataset.sizeValue;
var input=document.querySelector('.option-selector__btns input[value="'+size+'"]');
if(!input)return;
card.classList.toggle('is-unavailable',input.classList.contains('is-unavailable'));
});
}

  function filterImages() {
    var active = getCheckedValues();
    var optionGroups = getOptionGroups();

    ['media-viewer__item', 'media-thumbs__item'].forEach(function(cls){
      document.querySelectorAll('.' + cls).forEach(function(item){
        var img = item.querySelector('img');
        if (!img) return;
        var alt = img.alt.toLowerCase().trim();

        if (isAutoGeneratedAlt(alt)) {
          item.style.removeProperty('display');
          return;
        }

        // 每个维度（Color组、Size组...）各自找出 alt 里命中的最长选项值
        var taggedValues = [];
        optionGroups.forEach(function(sortedVals){
          var matched = matchLongestInGroup(alt, sortedVals);
          if (matched) taggedValues.push(matched);
        });

        // alt 不含任何已知选项值 -> 视为通用图片，始终显示
        if (taggedValues.length === 0) {
          item.style.removeProperty('display');
          return;
        }

        // alt 标注了的每个维度值，都必须出现在当前选中值里才显示
        var match = taggedValues.every(function(tag){
          return active.indexOf(tag) !== -1;
        });

        item.style.setProperty('display', match ? '' : 'none', 'important');
      });
    });
  }

  document.addEventListener('change', function(e){
    if (e.target.closest('.option-selector__btns')) {
      setTimeout(function(){
        updateAvailability();
updateCustomAvailability();
filterImages();
      }, 50);
    }
  });

  setTimeout(function(){
    updateAvailability();
updateCustomAvailability();
filterImages();
  }, 300);
})();
